import { ReactElement } from 'react';
import PropTypes from 'prop-types';
import FormHelperText from '@mui/material/FormHelperText';

/**
 * customized helper text for customized fields
 * displays the `error` if `error` and `touched`; otherwise it displays `helperText`
 * @param {boolean} touched indicates the input has been interacted with
 * @param {string} error the error message to display
 * @param {string|ReactElement} helperText default on-screen assistance
 * @returns {ReactElement} on-screen assistance when appropriate
 */
const CustomHelperText = ({ touched, error, helperText }) => {
	return (
		<FormHelperText error={touched && !!error}>
			{touched && error ? error : helperText}
		</FormHelperText>
	);
};

CustomHelperText.propTypes = {
	touched: PropTypes.bool.isRequired,
	error: PropTypes.string,
	helperText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};

export default CustomHelperText;
